import { Box, Grid2, Typography } from '@mui/material'
import React from 'react'
import { Grid_Gap } from '../../shared/constants'
import { NormalContainer, NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import { useTranerUnderCoorList } from '../../assets/api/useCoordinatorApi'
import useAuthStore from '../../store/useAuthStore'
import { TextSkeleton } from '../../shared/utils/SkeletonCom'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { StudentCount } from '../../shared/components/apartment/StudentCount'

const CoOrdinatorDash = () => {
    const { user } = useAuthStore();
    const { data: apartmentList, isLoading } = useTranerUnderCoorList(user?.id)
    const totalStudents = apartmentList?.apartments?.reduce((sum, item) => sum + (item?.student_count || 0), 0);

    return (
        <Box>
            <Grid2 container spacing={Grid_Gap}>
                <Grid2 children size={{ xs: 12, md: 6 }}>
                    <NormalContainerWithHeader >
                        < StudentCount count={totalStudents} isLoading={isLoading} text={"All Subscribed Students"} />
                    </NormalContainerWithHeader>

                </Grid2>
                <Grid2 children size={{ xs: 12, md: 6 }}>
                    <NormalContainerWithHeader headerText={"List of Apartments"}>

                        {!isLoading &&
                            apartmentList?.apartments?.map((item, index) => (
                                <Box key={index} sx={{ display: "flex", alignItems: 'center', my: 0.5 }}>
                                    <FiberManualRecordIcon sx={{ fontSize: "10px", mr: 1 }} /><Typography variant='body2'>{item?.apartment_name} - {item?.student_count} subscribed students</Typography>
                                </Box>
                            ))

                        }

                        {
                            isLoading &&
                            [...Array(5)].map((_, index) => (
                                <TextSkeleton key={index} />
                            ))

                        }

                    </NormalContainerWithHeader>
                </Grid2>
            </Grid2>
        </Box>
    )
}

export default CoOrdinatorDash